import url from '@/creditflowresearch/infrastructure/url';
import staticUrls from '@finsight/urls/static';
import URL from '@/creditflowresearch/Router/urlConstants';

const getMarketOverviewAllSchema = () => ({
  '@type': 'Dataset',
  name: 'USOA ABS Bond Issuance Overview',
  alternateName: 'Asset-Backed Securities Bond Issuance Overview United States Region',
  description: 'View recent and historical ABS new issue pricing, volume and research across Auto, CLO, CMBS, Credit Card, Equipment, Esoteric, Student Loans and RMBS for the United States region.',
  keywords: ['asset-backed securities', 'bonds', 'United States region'],
  license: staticUrls.getTermsOfUseUrl(),
  mainEntityOfPage: {
    '@type': 'WebPage',
    url: url.getUrl(URL.MARKET_OVERVIEW_ALL),
  },
  hasPart: [
    {
      '@type': 'Dataset',
      name: 'USOA ABS Top Sponsors',
      description: 'Trailing twelve months and recent USOA ABS Top Sponsors',
      license: staticUrls.getTermsOfUseUrl(),
    },
    {
      '@type': 'Dataset',
      name: 'Trailing twelve months and recent USOA ABS New Issues',
      description: 'Recent USOA ABS New Issue',
      license: staticUrls.getTermsOfUseUrl(),
    },
  ],
});

const getMarketOverviewIGCSchema = () => ({
  '@type': 'Dataset',
  name: 'Investment Grade Bond Issuance Overview',
  alternateName: 'Investment Grade Bond Securities Issuance Overview United States Region',
  description: 'Recent and historical global investment grade bond new issue pricing, volume and ratings tracker.',
  keywords: ['Investment Grade Bond securities', 'United States region'],
  license: staticUrls.getTermsOfUseUrl(),
  mainEntityOfPage: {
    '@type': 'WebPage',
    url: url.getUrl(URL.MARKET_OVERVIEW_IGC),
  },
  hasPart: [
    {
      '@type': 'Dataset',
      name: 'USOA IGC Top Sponsors',
      description: 'Trailing twelve months and recent USOA IGC Top Sponsors',
      license: staticUrls.getTermsOfUseUrl(),
    },
    {
      '@type': 'Dataset',
      name: 'Recent USOA IGC New Issue',
      description: 'Trailing twelve months and recent USOA IGC New Issues',
      license: staticUrls.getTermsOfUseUrl(),
    },
  ],
});

const getMarketOverviewHYCSchema = () => ({
  '@type': 'Dataset',
  name: 'High Yield Bond Issuance Overview',
  alternateName: 'High Yield Bond Issuance Overview United States Region',
  description: 'Recent and historical global high yield bond new issue pricing, volume and ratings tracker.',
  keywords: ['High Yield Bond securities', 'United States region'],
  license: staticUrls.getTermsOfUseUrl(),
  mainEntityOfPage: {
    '@type': 'WebPage',
    url: url.getUrl(URL.MARKET_OVERVIEW_HYC),
  },
  hasPart: [
    {
      '@type': 'Dataset',
      name: 'USOA HYC Top Sponsors',
      description: 'Trailing twelve months and recent USOA HYC Top Sponsors',
      license: staticUrls.getTermsOfUseUrl(),
    },
    {
      '@type': 'Dataset',
      name: 'Recent USOA HYC New Issue',
      description: 'Trailing twelve months and recent USOA HYC New Issues',
      license: staticUrls.getTermsOfUseUrl(),
    },
  ],
});

const getMarketOverviewConsumerSchema = () => ({
  '@type': 'Dataset',
  name: 'USOA ABS (ex CLO, CMBS & RMBS) Issuance Overview',
  alternateName: 'Auto, Credit Card, Equipment, Esoteric and Student Loan Asset-Backed Securities United States Region',
  description: 'View recent and historical global ABS new issue pricing, volume and research across Auto, Credit Card, Equipment, Esoteric and Student Loan ABS..',
  keywords: ['asset-backed securities', 'Auto', 'Credit Card', 'Equipment', 'Esoteric', 'Student Loans', 'United States region'],
  license: staticUrls.getTermsOfUseUrl(),
  mainEntityOfPage: {
    '@type': 'WebPage',
    url: url.getUrl(URL.MARKET_OVERVIEW_CONSUMER),
  },
  hasPart: [
    {
      '@type': 'Dataset',
      name: 'USOA ABS (ex CLO, CMBS & RMBS) Top Sponsors',
      description: 'Trailing twelve months and recent USOA ABS (ex CLO, CMBS & RMBS) Top Sponsors',
      license: staticUrls.getTermsOfUseUrl(),
    },
    {
      '@type': 'Dataset',
      name: 'Recent USOA ABS (ex CLO, CMBS & RMBS) New Issue',
      description: 'Trailing twelve months and recent USOA ABS (ex CLO, CMBS & RMBS) New Issues',
      license: staticUrls.getTermsOfUseUrl(),
    },
  ],

});

const getEmMarketOverviewSchema = () => ({
  '@type': 'Dataset',
  name: 'EM Issuance Overview',
  alternateName: 'Recent and historical Emerging Markets bond market',
  description: 'Recent and historical Emerging Markets bond market data covering issuance activity, deal flow, pricing, new issue volume, top underwriters and market commentary',
  keywords: ['Emerging Markets Bonds',
    'EM Bond Issuance',
    'EM Debt Market',
    'EM New Issues',
    'Emerging Markets Deal Flow',
    'EM Bond Volume Trends',
    'EM Underwriters',
    'EM Market Commentary',
    'EM Corporate Bonds',
    'EM Sovereign Bonds',
    'EM FIG Bonds',
    'LATAM Bond Issuance',
    'Global Emerging Debt Market'],
  license: staticUrls.getTermsOfUseUrl(),
  mainEntityOfPage: {
    '@type': 'WebPage',
    url: url.getUrl(URL.MARKET_OVERVIEW_EM),
  },
});

const getProfileOverviewSchema = (pathname: string) => {
  const [currentPath] = pathname.split('?');
  if (currentPath === URL.MARKET_OVERVIEW_ALL) {
    return getMarketOverviewAllSchema();
  }
  if (currentPath === URL.MARKET_OVERVIEW_HYC) {
    return getMarketOverviewHYCSchema();
  }
  if (currentPath === URL.MARKET_OVERVIEW_CONSUMER) {
    return getMarketOverviewConsumerSchema();
  }
  if (currentPath === URL.MARKET_OVERVIEW_EM) {
    return getEmMarketOverviewSchema();
  }
  return getMarketOverviewIGCSchema();
};

export default getProfileOverviewSchema;
